import { useState } from 'react';
import { heroCovers, heroStats, heroTags } from '@/mocks/homeData';

const searchScopes = ['长图深扒', '时间线', '话题标签'];

export default function Hero() {
  const [scope, setScope] = useState(searchScopes[0]);

  return (
    <section id="top" className="relative w-full overflow-hidden bg-background-50 border-b border-background-200">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-24 -left-24 w-[380px] h-[380px] rounded-full bg-primary-100/50 blur-3xl"></div>
        <div className="absolute bottom-[-120px] right-[10%] w-[320px] h-[320px] rounded-full bg-accent-100/60 blur-3xl"></div>
      </div>

      <div className="relative px-4 md:px-6 lg:px-10 py-12 md:py-16 lg:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-center">
          <div className="lg:col-span-7 animate-rise">
            <div className="inline-flex items-center gap-2 h-7 px-3 rounded-full bg-primary-100/80 text-primary-800 text-xs font-label">
              <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-dot"></span>
              黑料图文 · 深扒解析专栏
            </div>

            <h1 className="mt-6 font-heading font-bold text-foreground-950 leading-[1.18] text-3xl md:text-5xl">
              黑料图文深扒长图
              <span className="block mt-1 text-primary-600">逐层拆解事件内幕</span>
            </h1>

            <p className="mt-6 text-sm md:text-base leading-relaxed text-foreground-700 max-w-2xl font-body">
              黑料图文深扒解析栏目，用长图与多图对比拆解事件细节。适合想了解前因后果、幕后关联与时间线的用户，
              从聊天记录到公开动态逐层还原，一次看清黑料图文内幕全貌。
            </p>

            <div className="mt-8 w-full max-w-2xl bg-background-100 border border-background-300 rounded-lg p-3 md:p-4">
              <div className="flex items-center gap-1.5 mb-3">
                {searchScopes.map((item) => (
                  <button
                    key={item}
                    type="button"
                    onClick={() => setScope(item)}
                    className={`h-8 px-3 rounded-md text-xs md:text-sm font-label whitespace-nowrap transition-colors cursor-pointer ${
                      scope === item
                        ? 'bg-foreground-950 text-background-50'
                        : 'text-foreground-700 hover:bg-background-200'
                    }`}
                  >
                    {item}
                  </button>
                ))}
                <span className="ml-auto hidden sm:inline text-xs text-foreground-500 font-label">按「{scope}」检索</span>
              </div>
              <div className="flex flex-col sm:flex-row items-stretch gap-2">
                <div className="flex-1 flex items-center gap-2 h-11 px-3 rounded-md bg-background-50 border border-background-300 focus-within:border-primary-400 transition-colors">
                  <span className="w-5 h-5 flex items-center justify-center text-foreground-500">
                    <i className="ri-file-search-line text-lg"></i>
                  </span>
                  <input
                    type="text"
                    placeholder="输入关键词，例如「48 小时时间线」"
                    className="w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 outline-none font-label"
                  />
                </div>
                <button
                  type="button"
                  className="h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-label font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer flex items-center justify-center gap-2"
                >
                  <i className="ri-radar-line text-base"></i>
                  开始深扒
                </button>
              </div>
            </div>

            <div className="mt-6 flex flex-wrap items-center gap-2">
              <span className="text-xs text-foreground-500 font-label">热门标签</span>
              {heroTags.map((tag) => (
                <a
                  key={tag}
                  href="#topics"
                  className="h-7 px-3 inline-flex items-center rounded-full bg-secondary-100 text-secondary-900 text-xs font-label hover:bg-secondary-200 transition-colors whitespace-nowrap"
                >
                  {tag}
                </a>
              ))}
            </div>

            <div className="mt-9 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 border-t border-background-200 pt-6">
              {heroStats.map((stat) => (
                <div key={stat.id}>
                  <p className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">{stat.value}</p>
                  <p className="mt-1 text-xs md:text-sm text-foreground-600 font-label">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5 animate-rise">
            <div className="relative mx-auto max-w-[420px] lg:max-w-none">
              <div className="relative w-full h-[300px] md:h-[380px] rounded-lg overflow-hidden border border-background-300 bg-background-200">
                <img
                  src={heroCovers[0]}
                  alt="黑料图文深扒长图封面"
                  title="黑料图文长图深扒封面"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950/70 to-transparent p-4">
                  <p className="text-xs text-background-50 font-label tracking-wide">封面驱动 · 逐张比对</p>
                </div>
              </div>

              <div className="mt-3 grid grid-cols-2 gap-3">
                <div className="relative w-full h-[140px] md:h-[170px] rounded-lg overflow-hidden border border-background-300">
                  <img
                    src={heroCovers[1]}
                    alt="黑料图文聊天记录拆解封面"
                    title="黑料图文解析聊天记录封面"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="relative w-full h-[140px] md:h-[170px] rounded-lg overflow-hidden border border-background-300">
                  <img
                    src={heroCovers[2]}
                    alt="黑料图文时间线还原封面"
                    title="黑料图文内幕时间线封面"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>

              <div className="absolute -left-3 md:-left-6 bottom-24 bg-background-50 border border-background-200 rounded-lg px-4 py-3 shadow-none">
                <p className="text-xs text-foreground-500 font-label">本周深扒长图</p>
                <p className="font-heading text-xl font-bold text-primary-600">42 张</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}